/**
 * @ngdoc Filter
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .filter('vrmSnakeCase', vrmSnakeCase);

    function vrmSnakeCase() {
        return function(text){
            return text.replace(/([A-Z])/g, function($1){return "_"+$1.toLowerCase();});
        }
    }

})();
